import { CSSProperties, ReactNode, Ref } from 'react';
import { ErrorMessage, FormLabel } from '../helpers';
import TextInputBase from './TextInputBase';
import { useContextField } from '../../../api';
import { InputBaseComponentProps } from '@material-ui/core';

export default (props: {
    name?: string;
    autoFocus?: boolean;
    value?: string | number;
    label?: string | ReactNode;
    placeholder?: string;
    disabled?: boolean;
    onChange?(value?: string): void;
    type?: string;
    maxLength?: string;
    endAdornment?: ReactNode;
    className?: string;
    inputProps?: InputBaseComponentProps;
    style?: CSSProperties;
    ref?: Ref<any>;
    autoComplete?: string;
}) => {
    const [field, _, helper] = props.name ? useContextField<string | undefined>(props.name) : [];
    const { onChange, label, ...rest } = props;
    return <>
        <FormLabel label={label} />
        <TextInputBase
            {...rest}
            {...field}
            variant="outlined"
            onChange={e => {
                onChange && onChange(e.target.value);
                helper && helper.setValue(e.target.value);
            }}
            onBlur={e => {
                helper && helper.setValue(e.target.value.trim());
            }}
        />
        <ErrorMessage name={field?.name} />
    </>
}
